<template>
  <div class="live">
    <div class="live">
      <div class="title">{{ $t('homePage.live.title') }}</div>
      <div class="exhibitorsLive">
        <!-- 轮播开始 -->

        <!-- swiper -->
        <swiper ref="mySwiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in lunItem" :key="index">
            <div class="card" @click="goDetail(item)">
              <div class="backImg">
                <img :src="item.backImgUrl" alt="" class="fengmian"/>
                <span class="bottomImg" @click.stop="collection(item,3)">
									<img v-if="item.collectStatus" alt="" src="../../static/collent_yello.png"/><!--显示金色-->
									<img v-else alt="" src="../../static/collent.png"/><!--显示无色-->
								</span>
                <div class="fixed">
                  <div class="banner-btn">
                    <img alt="" src="../../static/ico_vedio.png">
                  </div>
                </div>
              </div>

              <div class="text">{{ item.videoTitle }}</div>

              <div class="date">
                <div class="img">
                  <img alt="" src="../../static/ico_time.png"/>
                </div>
                <span>{{ item.date }}</span>
                <!--              <span>{{ item.videoTime }}</span>-->
              </div>

              <div class="company">{{ item.company }}</div>
            </div>

          </swiper-slide>
        </swiper>

        <!-- 分页 -->
        <div v-if="lunItem.length>4" slot="pagination" class="swiper-pag"></div>

        <!-- 轮播结束 -->
      </div>

      <!--查看更多-->
      <router-link to="live">
        <div class="lookMore">{{ $t('common.viewMore') }}</div>
      </router-link>
    </div>
    <div v-show="qrShow" class="alert_mess">
      <img class="close" src="../../static/close.png" @click="closeQr"/>
      <div>
        <div class="qrcode"><img :src="qrcode" :alt="$t('homePage.live.qrAlt')"></div>
        <p>{{ $t('live.tip') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import {getexhibitionLive} from "../../../api/homePage";
import {forMat} from "../../../utils/common";

export default {
  name: "exhibitorsLive",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      //swiper 初始化
      swiperOption: {
        // loop: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        loopFillGroupWithBlank: true,
        spaceBetween: 31,
        autoplay: {
          delay: 7000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pag",
          clickable: true, //允许分页点击跳转
          bulletActiveClass: 'my-bullet-active',
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      //轮播子元素
      lunItem: [],
      //收藏按钮
      collent_toggle: false,
      //弹窗二维码
      qrcode: null,
      qrShow: false,
    };
  },
  methods: {
    async getexhibitionLive() {
      try {
        let {data} = await getexhibitionLive();
        data.data.list.forEach((item, i) => {

          if(item.coverPhoto.indexOf("http")  == -1){
            item.coverPhoto= forMat() +  item.coverPhoto;
          }

          if(item.videoAddress.indexOf("http")  == -1){
            item.videoAddress= forMat() +  item.videoAddress;
          }

          this.lunItem.push({
            backImgUrl:  item.coverPhoto,
            videoTitle: item.liveCn,
            date: item.startDate,
            company: item.exhibitorNameCn,
            id: item.id,
            videoAddress:  item.videoAddress,//二位码也存在此字段里
            videoType: item.videoType,//视频类型1=上传视频2=直播外链3=直播入口二维码
            collectStatus: item.collectStatus
          })
        })
        // this.lunItem.push({
        //   backImgUrl: require('../../static/占位-直播-详情.png'),
        //   videoTitle: '测试二维码用的前端假数据测试二维码用的前端假数据测试二维码用的前端假数据',
        //   date: 'item.startDate',
        //   company: 'item.exhibitorNameCn',
        //   id: 'i604f415f35e8423086588823bad435fa',
        //   videoAddress: require('../../static/占位-直播-详情.png'),//二位码也存在此字段里
        //   videoType: '3',//视频类型1=上传视频2=直播外链3=直播入口二维码
        //   collectStatus: 0
        // })
      } catch (e) {
        console.log(e)
      }
    },

    //使用父组件收藏方法
    collection(item, type) {
      this.$parent.collection(item, type)
    },

    //跳转至详情
    goDetail(item) {
      console.log(item)
      // 3=直播入口二维码
      item.videoType == 3 && (this.qrcode = item.videoAddress) && (this.qrShow = true)
      if (item.videoType == 1 || item.videoType == 2) {
        this.$router.push({
          name: 'live_detail',
          query: {
            userId: item.id
          },
        });
      }
    },

    closeQr() {
      this.qrcode = null
      this.qrShow = false
    }
  },
  mounted() {
    this.getexhibitionLive()
    // console.log('test',this.lunItem.length);
  },
};
</script>
<style lang="scss" scoped>
.live {
  width: 100%;
  height: fit-content;
  background-color: #f6f6f7;
  //	border: 1px solid red;
  height: fit-content;
  padding-bottom: 1px;

  .title {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding-top: 59px;
    padding-bottom: 52px;
    box-sizing: border-box;
  }

  .exhibitorsLive {
    width: 1294px;      //加6*4px是因为轮播内容要有左边距才能在移入时左侧显示出阴影
    margin: 0 auto;
    height: 374px;
    //	border: 1px solid blue;

    .swiper-slide {

      .card {
        background-color: white;
        cursor: pointer;
        width: 295px;
        margin: 0 3px;  //外边距加3px显示卡片阴影
        transition: all .3s;

        &:hover {
          box-shadow: 0px 0px 3px #9fa3a5;

          .backImg .fixed {
            visibility: visible;
            opacity: 1;
          }

          .text {
            color: #006FB8;
          }
        }

        .backImg {
          box-sizing: border-box;
          width: 100%;
          height: 190px;

          .fengmian {
            width: 100%;
            height: 100%;
          }

          .bottomImg {
            position: absolute;
            right: 12px;
            top: 12px;
            z-index: 666;

            span {
              width: 30px;
              height: 29px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .fixed {
            width: 295px;
            height: 190px;
            position: absolute;
            top: 0;
            background-color: rgba(30, 30, 30, 0.3);
            //display: none;
            visibility: hidden;
            opacity: 0;
            z-index: 333;
            transition: opacity .3s;


            img {
              margin: 71px 123px;
            }
          }
        }

        .text {
          width: 237px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 21px;

          margin: 0 auto;
          margin-top: 19px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          height: 42px;
        }

        .date {
          width: 237px;
          margin: 0 auto;
          margin-top: 19px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .img {
            width: 24px;
            height: 24px;

            img {
              width: 24px;
              height: 24px;
            }
          }

          span {
            margin-left: 6px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
         /*    color: #fdd000; */
         color: #333333;
          }
        }

        .company {
          margin: 0 auto;
          padding: 0px 28px;
          border-top: 1px solid #E0E0E0;
          height: 58px;
          margin-top: 19px;

          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 55px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }

  a {
    display: block;
    text-decoration: none;

    .lookMore {
      width: 247px;
      height: 44px;
      border: 1px solid #333333;
      border-radius: 4px;
      margin: 0 auto;
      text-align: center;
      line-height: 44px;
      margin-top: 80px;
      margin-bottom: 100px;
      color: #333333;
      font-size: 16px;
    }
  }

  .alert_mess {
    width: 400px;
    height: 530px;
    box-sizing: border-box;
    text-align: center;
    // border: 1px solid black;
    box-shadow: 0px 0px 51px 0px #c1c6cb;
    background: white;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;


    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 15px;
      top: 15px;
      cursor: pointer;
    }

    .qrcode {
      max-width: 300px;
      max-height: 450px;

      img {
        width: 100%;
        height: 100%;
        max-width: 300px;
        max-height: 450px;
      }
    }

    p {
      font-size: 16px;
      font-family: Microsoft YaHei;
      margin-top: 21px;
      font-weight: 400;
      color: #333333;
    }
  }
}
</style>

<style scoped>
/*-------------------轮播图样式修改---------------------------*/
.swiper-slide {
  width: 200px;
  height: 374px;
  /* background-color: #2ea9e2 !important; */
}

/* 修改轮播元素的尺寸 */
.swiper-pag {
  height: 10px;
  width: 74px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  position: static !important;
  margin-top: 31px;
}

/*修改轮播图指示点的样式 */
/*.swiper-pag .swiper-pagination-clickable .swiper-pagination-bullets >>> .swiper-pagination-bullet-active {*/
/*	background-color: #fccf00 !important;*/
/*}*/
/* >>> .swiper-pagination-bullet.my-bullet-active {
  background: #fccf00 !important;
  opacity: 1;
} */
</style>
